export default __webpack_public_path__ + "static/media/icon_union_pay_express.d6750648.png";